import { CLIENT_CONFIG } from '../../dealers/fresh/config';
import { createStore, createEvent } from 'effector';

export const setDealerId = createEvent<number>();
export const setFreshCrmDealerId = createEvent<number>();
const setResolvedDealerId = createEvent<number>();
export const $dealerId = createStore<number>(0)
  .on(setDealerId, (_, id) => id)
  .on(setFreshCrmDealerId, () => 0)
  .on(setResolvedDealerId, (_, id) => id);

// Проверка подключения к интернету
export const $estabilishInternet = createStore<boolean>(true);
export const setEstabilishInternetFx = createEvent<boolean>();
$estabilishInternet.on(setEstabilishInternetFx, (_, state) => state);

// Таймер парсинга
let dealerInfoSource: EventSource | null = null;

type Counters = {
  id: number;
  allDealerCount: number;
  dealerCount: number;
  name: string;
  theme: "default" | "syndicate";
};

export const setCountersDataFx = createEvent<Counters | null>();
export const $countersData = createStore<Counters | null>(null)
  .on(setCountersDataFx, (_, data) => data);

const subscribeToDealerInfo = (streamPath: string) => {
  if (dealerInfoSource) {
    dealerInfoSource.close();
    dealerInfoSource = null;
  }

  setCountersDataFx(null);
  const source = new EventSource(`${CLIENT_CONFIG.NODE_API_URL}${streamPath}`);
  dealerInfoSource = source;

  source.addEventListener("dealer.info", ((event: MessageEvent<string>) => {
    try {
      const payload = JSON.parse(event.data) as { success: boolean; data?: Counters };

      if (payload.success && payload.data) {
        setResolvedDealerId(payload.data.id);
        setCountersDataFx(payload.data);
        setEstabilishInternetFx(true);
      }
    } catch {
      setEstabilishInternetFx(false);
    }
  }) as EventListener);

  source.addEventListener("dealer.error", (() => {
    setEstabilishInternetFx(false);
  }) as EventListener);

  source.onerror = () => {
    setEstabilishInternetFx(false);
  };
};

setDealerId.watch((dealerId) => {
  if (!dealerId) {
    return;
  }

  subscribeToDealerInfo(`/dealers/${dealerId}/stream`);
});

setFreshCrmDealerId.watch((freshCrmDealerId) => {
  if (!freshCrmDealerId) {
    return;
  }

  subscribeToDealerInfo(`/dealers/crm/${freshCrmDealerId}/stream`);
});

export const $currentElementView = createStore<number>(0);
export const setCurrentViewFx = createEvent<number>();
export const nextViewFx = createEvent();
export const prevViewFx = createEvent();
$currentElementView.on(setCurrentViewFx, (_, data) => data);
$currentElementView.on(nextViewFx, (_, data) => _ + 1);
$currentElementView.on(prevViewFx, (_, data) => _ - 1);

const titlesMap: Record<number, string> = {
  0: 'Добро пожаловать в автосалон!',
  1: 'Введите Ваш\nномер телефона',
  2: 'Выберите\nменеджера',
  3: ' ',
};

export const $currentTitle = $currentElementView.map(
  (view) => titlesMap[view] || 'Добро пожаловать в автосалон!'
);

enum Screen {
  BASE = "",
  BUY = "buy",
  SELL = "sell",
  SERVICE = "service",
}
export const $currentScreen = createStore<Screen>(Screen.BASE);
export const setCurrentScreenFx = createEvent<any>();
$currentScreen.on(setCurrentScreenFx, (_, data) => data);

// Type Query
export const $typeQuery = createStore<string>("");
export const setTypeQueryFx = createEvent<string>();
$typeQuery.on(setTypeQueryFx, (_, typeQuery) => typeQuery);

export const $subTypeQuery = createStore<string>("");
export const setSubTypeQueryFx = createEvent<string>();
$subTypeQuery.on(setSubTypeQueryFx, (_, subTypeQuery) => subTypeQuery);

// Show Sell Variants
export const $showSellVariants = createStore(false);
export const setShowSellVariantsFx = createEvent();
$showSellVariants.on(setShowSellVariantsFx, (_, state) => state);

// Show Buy Variants
export const $showBuyVariants = createStore(false);
export const setShowBuyVariantsFx = createEvent();
$showBuyVariants.on(setShowBuyVariantsFx, (_, state) => state);

// Keyboard
// export const $keyboardVisual = createStore("");
// export const $keyboardValue = createStore("");
// export const $keyboardMask = createStore("");
// export const setKeyboardVisualFx = createEvent();
// export const setKeyboardValueFx = createEvent();
// export const setKeyboardMaskFx = createEvent();
// $keyboardVisual.on(setKeyboardVisualFx, (_, data) => data)
// $keyboardValue.on(setKeyboardValueFx, (_, data) => data)
// $keyboardMask.on(setKeyboardMaskFx, (_, data) => data)

// const [phone, setPhone] = React.useState<string>("");
//   const [selectedKeyPhone, setSelectedKeyPhone] = React.useState(0);
//   const [hasEditString, setHasEditString] = React.useState(false);

// Phone Number
export const $phone = createStore("");
export const setPhoneFx = createEvent<string>();
$phone.on(setPhoneFx, (_, data) => data);

export const $selectedKeyPhone = createStore<number>(0);
export const setSelectedKeyPhoneFx = createEvent<number>();
$selectedKeyPhone.on(setSelectedKeyPhoneFx, (_, data) => data);

export const $hasEditString = createStore<boolean>(false);
export const setHasEditStringFx = createEvent<boolean>();
$hasEditString.on(setHasEditStringFx, (_, data) => data);


// Manager
export const $managerCode = createStore<string | null>(null);
export const setManagerCodeFx = createEvent<string | null>();
$managerCode.on(setManagerCodeFx, (_, managerCode) => managerCode);

$managerCode.watch((data) => console.log('MANAGER CODE => ', data));

// Сторы модалок
export const $docPrivacyPolicyShow = createStore<boolean>(false);
export const showDocPrivacyFx = createEvent<void>();
export const hideDocPrivacyFx = createEvent<void>();
$docPrivacyPolicyShow
  .on(showDocPrivacyFx, () => true)
  .on(hideDocPrivacyFx, () => false)

// Клиентский код для менеджера
export const $clientCode = createStore<string | null>(null);
export const setClientCodeFx = createEvent<string | null>();
$clientCode.on(setClientCodeFx, (_, clientCode) => clientCode);

// State wrote on keyboard
// export const $stateWrote = createStore("phone");
// export const setStateWroteFx = createEvent();
// $stateWrote.on(setStateWroteFx, (_, stateWrote) => stateWrote);

// Image
// export const $personalImage = createStore("");
// export const setPersonalImageFx = createEvent();
// $personalImage.on(setPersonalImageFx, (_, personalImage) => personalImage);

// Image
// export const $viewNotify = createStore(false);
// export const setViewNotifyFx = createEvent();
// $viewNotify.on(setViewNotifyFx, (_, state) => state);
